import { useTranslation } from "react-i18next";
import data from "../../../data";
import { Col, Row } from "react-bootstrap";
import {
  faNetworkWired,
  faIndustry,
  faVest,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import css from "./VKIVIU.module.css";

function DefinitionVKIVIU() {
  const { t } = useTranslation();

  const definitionIconMapping = {
    "Perusahaan API-P": faVest,
    "Perusahaan industri": faIndustry,
    "VIU Industri": faIndustry,
    "VIU Non-Industri": faNetworkWired,
    "VIU Konsumsi": faVest,
  };

  return (
    <>
      <div className="tkdn-container-definition">
        <div className="tkdn-section-header">
          <div className="border-title-vpti" />
          <h1 className="tkdn-section-title">{t("vkiviu_definition.title")}</h1>
        </div>
        <div className="container-about-img">
          {Array.from(data.vkiviu_definition.definition, (definition, i) => {
            return (
              <Row>
                <Col key={i}>
                  <img
                    className="benefit-img"
                    src={"/images/VKIVIU/" + definition.title + ".png"}
                    alt={definition}
                  />
                  <h2 className="lvv-subtitle">
                    {t(`vkiviu_definition.definition.${i}.title`)}
                  </h2>
                  <p className="tkdn-text">
                    {t(`vkiviu_definition.definition.${i}.desc`)}
                  </p>
                  <div className={css.typeContainer}>
                    {Array.from(definition.type, (type, j) => {
                      return (
                        <div className={css.typeList}>
                          <FontAwesomeIcon
                            icon={
                              definitionIconMapping[definition.type[j].title]
                            }
                          />
                          <div className={css.typeListItem}>
                            <b>
                              {t(
                                `vkiviu_definition.definition.${i}.type.${j}.title`,
                              )}
                            </b>
                            <p>
                              {t(
                                `vkiviu_definition.definition.${i}.type.${j}.desc`,
                              )}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    </>
  );
}
export default DefinitionVKIVIU;
